"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class GridColumnFilterUtil {
    static changeColumnVisibility({ grid, checked, heading }) {
        const filterId = grid.gridConfig.filterId;
        if (!filterId) {
            throw new Error(`GridConfig with caption: ${grid.gridConfig.caption} and summary: ${grid.gridConfig.tableSummary} needs a filter id to use GridColumnFilterUtil.changeColumnVisibility`);
        }
        const localStorageMap = new fmko_ts_common_1.LocalStorageMap(filterId);
        localStorageMap.load();
        localStorageMap.setValue(heading, checked);
        localStorageMap.save();
        const correspondingColumns = grid.getTableElement().querySelectorAll(`[data-column-filter-id="${heading}"]`);
        for (const correspondingColumn of Array.from(correspondingColumns)) {
            (0, fmko_ts_common_1.setElementVisible)(correspondingColumn, checked);
        }
    }
    static getFilterHeader(columnConfig) {
        const gridConfig = columnConfig.grid.gridConfig;
        const filterId = gridConfig.filterId;
        const columnIndex = gridConfig.columnConfigs.findIndex(column => column === columnConfig);
        if (!filterId) {
            return undefined;
        }
        if (typeof columnConfig.heading === "string") {
            const localStorageMap = new fmko_ts_common_1.LocalStorageMap(filterId);
            localStorageMap.load();
            const columnConfigVisible = localStorageMap.getValue(columnConfig.heading)
                ?? columnConfig.canFilter?.visibleByDefault
                ?? true;
            return {
                header: columnConfig.heading,
                columnIndex,
                visible: columnConfigVisible
            };
        }
    }
}
exports.default = GridColumnFilterUtil;
//# sourceMappingURL=GridColumnFilterUtil.js.map